import { i18n as _i18n } from "@lingui/core";
import { formNames, MktSelectors } from '@wkda/carlead-creation-form';
import { useModulesStore } from '@wkda/funnel-components';
import { BaseField, renderFieldVerticalWrapper } from '../BaseField';
import { selectFieldRenderer } from '../fieldRenderers/selectFieldRenderer';
import { useAutoSelectForDataFields, useSyncValues } from '../hooks/useAutoSelectForDataFields';
import { useDynamicCartypesFetcher } from '../hooks/useDynamicCartypesFetcher';
import { useStateMachineForDataFields } from '../hooks/useStateMachineForFields';
import { jsx as _jsx } from "react/jsx-runtime";
export function SplitBuiltDates(_ref) {
  let {
    label = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.label.builtDate'
    }),
    placeholder = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.placeholder.builtDate'
    }),
    className,
    onChange,
    ...props
  } = _ref;
  const name = formNames.builtDate;
  const {
    carTypesSplitModule: {
      getBuiltDates
    }
  } = useModulesStore();
  const {
    isFieldEnabled,
    sendUserSelect,
    stateFieldClassNames,
    fieldFetchParams
  } = useStateMachineForDataFields({
    name
  });
  const {
    data
  } = useDynamicCartypesFetcher({
    name,
    enabled: isFieldEnabled,
    queryFn: getBuiltDates,
    //@ts-expect-error TODO: better type context values
    params: fieldFetchParams,
    responseTransformConfig: {
      order: 'desc'
    }
  });
  useAutoSelectForDataFields(name, data);
  useSyncValues(name);
  return /*#__PURE__*/_jsx(BaseField, {
    label: label,
    name: name,
    MktSelector: MktSelectors.builtDate,
    topContainerClassName: stateFieldClassNames,
    disabled: !isFieldEnabled || data.length === 0,
    renderFieldWrapper: renderFieldVerticalWrapper,
    renderFieldComponent: function fieldRenderer(_ref2) {
      let {
        name,
        mktSelector
      } = _ref2;
      return selectFieldRenderer({
        name,
        mktSelector,
        placeholder,
        className,
        options: data,
        disabled: !isFieldEnabled || data.length === 0,
        onChange(evt) {
          onChange === null || onChange === void 0 || onChange(evt);
          sendUserSelect(evt.target.value);
        }
      });
    },
    ...props
  });
}